/**
 * AlmadarPostComplianceAsCodeENAlmadarPostComplianceAsCodeENPage
 *
 * Page component for AlmadarPostComplianceAsCodeENAlmadarPostComplianceAsCodeENPage
 * Path: /blog/compliance-as-code
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostComplianceAsCodeENPostPageView as __AlmadarPostComplianceAsCodeENPostPageView } from '@/components/traits/AlmadarPostComplianceAsCodeENPostPageView';
import { AlmadarPostComplianceAsCodeENPostAnalyticsView as __AlmadarPostComplianceAsCodeENPostAnalyticsView } from '@/components/traits/AlmadarPostComplianceAsCodeENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostComplianceAsCodeENAlmadarPostComplianceAsCodeENPageProps {
  // Add any page-level props here
}

export function AlmadarPostComplianceAsCodeENAlmadarPostComplianceAsCodeENPage(_props: AlmadarPostComplianceAsCodeENAlmadarPostComplianceAsCodeENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostComplianceAsCodeENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostComplianceAsCodeENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostComplianceAsCodeENAlmadarPostComplianceAsCodeENPage;
